// Persistent drawer flyouts use 1300. Bar + poppers stay below so full drawers cover them.
// When transposition is expanded, flyouts drop to DRAWER_TOGGLE_BELOW_BAR_Z so they don't sit on the panel.
export const DASHBOARD_BAR_Z = 1100
export const DASHBOARD_POPPER_Z = 1190
export const DRAWER_TOGGLE_Z = 1300
export const DRAWER_TOGGLE_BELOW_BAR_Z = 1080
